import React from 'react'
import './header.css'
import Cta from './Cta';
import me from '../../asset/profile3.jpg'
import Headersocial from './Headersocial';
const header = () => {
  return (
    <header>
      <div className="container header_container">
        <h5>Hello i'm</h5>
        <h1>Rahul Batham</h1>
        <h5 className="">Fullstack Developer</h5>
        <Cta />
        <Headersocial />

        <div className="me">
          <div className="flex">
          <img src={me} alt="me" />
          </div>
        </div>
        <a href="#contact" className='scroll__down'>Scroll_down</a>


      </div>
    </header>
  )
}

export default header